// front/src/components/layout/Navbar/Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  NavbarContainer,
  Logo,
  IconContainer,
  Icon,
  LogoutButton,
  NotificationDropdown,
  UserDropdown,
  DropdownItem,
  NotificationBadge,
  NotificationItem,
  NotificationGrip,
  NotificationConteudo,
  NotificationLinhaTopo,
  NotificationTitulo,
  NotificationData,
  NotificationMensagem,
  NotificationEmpty,
  NotificationErro,
  NotificationFooter,
  MarcarTodasButton
} from './Navbar.styles';
import useNotificacoes from '../../../hooks/useNotificacoes';
import { rotaNotificacao } from '../../../constants/notificacoes';

const formatarData = (valor) => {
  if (!valor) return '';
  return new Date(valor).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};

const Navbar = ({ 
  logo = "TECNEPS",
  showHome = true,
  showNotifications = true,
  showProfile = true,
  showLogout = true,
  onLogout,
  className = '',
  user = null
}) => {
  const [isNotificationOpen, setNotificationOpen] = useState(false);
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const notificacaoRef = useRef(null);
  const { contagem, itens, carregando, erro, carregarLista, marcarLida, marcarTodas } = useNotificacoes();

  useEffect(() => {
    if (!isNotificationOpen) return undefined;
    const aoClicarFora = (evento) => {
      if (notificacaoRef.current && !notificacaoRef.current.contains(evento.target)) {
        setNotificationOpen(false);
      }
    };
    document.addEventListener('mousedown', aoClicarFora);
    return () => document.removeEventListener('mousedown', aoClicarFora);
  }, [isNotificationOpen]);

  const toggleNotificationDropdown = () => {
    const abrindo = !isNotificationOpen;
    setNotificationOpen(abrindo);
    setUserDropdownOpen(false);
    if (abrindo) {
      carregarLista();
    }
  };

  const handleNotificacaoClick = (notificacao) => {
    marcarLida(notificacao.id);
    setNotificationOpen(false);
    const rota = rotaNotificacao(notificacao.tipo);
    if (rota) {
      navigate(rota);
    }
  };

  const toggleUserDropdown = () => {
    setUserDropdownOpen(!isUserDropdownOpen);
    setNotificationOpen(false);
  };

  const getCargoId = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      return Number(user?.cargoId) || null;
    } catch {
      return null;
    }
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    setUserDropdownOpen(false);
  };

  const cargoId = getCargoId();

  return (
    <NavbarContainer className={className}>
      <Logo>{logo}</Logo>
      
      <IconContainer>
        {showHome && (
          <Icon>
            <Link 
              to={cargoId === 4 ? "/DashboardES" : "/DashboardInicio"}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <span className="material-symbols-outlined">home</span>
            </Link>
          </Icon>
        )}
        
        {showNotifications && (
          <Icon ref={notificacaoRef} onClick={toggleNotificationDropdown}>
            <span className="material-symbols-outlined">notifications</span>
            {contagem > 0 && (
              <NotificationBadge>{contagem > 9 ? '9+' : contagem}</NotificationBadge>
            )}
            {isNotificationOpen && (
              <NotificationDropdown onClick={(e) => e.stopPropagation()}>
                {carregando && <NotificationEmpty>Carregando...</NotificationEmpty>}
                {!carregando && erro && <NotificationErro>{erro}</NotificationErro>}
                {!carregando && !erro && itens.length === 0 && (
                  <NotificationEmpty>Nenhuma notificação</NotificationEmpty>
                )}
                {!carregando && itens.map((n) => (
                  <NotificationItem
                    key={n.id}
                    $lida={n.lida}
                    onClick={() => handleNotificacaoClick(n)}
                  >
                    <NotificationGrip className="material-symbols-outlined">
                      more_vert
                    </NotificationGrip>
                    <NotificationConteudo>
                      <NotificationLinhaTopo>
                        <NotificationTitulo>{n.titulo}</NotificationTitulo>
                        <NotificationData>{formatarData(n.createdAt)}</NotificationData>
                      </NotificationLinhaTopo>
                      <NotificationMensagem title={n.mensagem}>{n.mensagem}</NotificationMensagem>
                    </NotificationConteudo>
                  </NotificationItem>
                ))}
                {!carregando && itens.length > 0 && (
                  <NotificationFooter>
                    <MarcarTodasButton onClick={marcarTodas}>
                      Marcar todas como lidas
                    </MarcarTodasButton>
                  </NotificationFooter>
                )}
              </NotificationDropdown>
            )}
          </Icon>
        )}
        
        {showProfile && (
          <Icon onClick={toggleUserDropdown}>
            <Link to="/Profile" style={{ color: "inherit", textDecoration: "none" }}>
              <span className="material-symbols-outlined" style={{ color: "white" }}>
                account_circle
              </span>
              <span className="material-symbols-outlined">keyboard_arrow_down</span>
            </Link>
            {isUserDropdownOpen && (
              <UserDropdown>
                <DropdownItem onClick={() => setUserDropdownOpen(false)}>
                  <Link to="/Profile" style={{ color: "inherit", textDecoration: "none" }}>
                    Meu Perfil
                  </Link>
                </DropdownItem>
              </UserDropdown>
            )}
          </Icon>
        )}
        
        {showLogout && (
          <LogoutButton onClick={handleLogout}>
            Sair
          </LogoutButton>
        )}
      </IconContainer>
    </NavbarContainer>
  );
};

export default Navbar;